import React, { useEffect, useState } from 'react';

import { SelectBox, SelectOption } from '../../../../ui/widgets/select/select';

export interface SearchBoxProps {
  title?: string;
  options: SelectOption[];
  // Value if already set
  value?: SelectOption;
  onSearch?(option?: SelectOption): void;
  key?: number;
}

export const SearchBox = ({ title, options, value, onSearch }: SearchBoxProps): JSX.Element => {
  const [searchOptions, setSearchOptions] = useState<SelectOption[]>(options);

  // Update if options changed
  // TODO: Replace this with a key value based on options prop
  useEffect(() => {
    setSearchOptions(options);
  }, [options]);

  const onSelect = (v: SelectOption | undefined) => {
    if (onSearch) return onSearch(v);
  };

  return (
    <SelectBox
      options={searchOptions}
      onChange={onSelect}
      value={value}
      placeholder={'Search...'}
      xsSpan={2}
      title={title}
      isClearable={true}
      clearSelection={true}
    />
  );
};



// WEBPACK FOOTER //
// ./src/admin/ui/components/search-box/search-box.tsx